module.exports = __webpack_public_path__ + "static/media/LHOutSwingDark.aaf0bdde.svg";